





















import { Component, Vue } from 'vue-property-decorator';
import * as humanseg from '@paddlejs-models/humanseg/lib/index_gpu';
import Camera from '@paddlejs-mediapipe/camera';
import { sendShowLog, sendClickLog } from '@/common/js/log';

@Component
export default class HumanStream extends Vue {
    mounted(): void {
        async function load() {
            await humanseg.load(true, true);
            camera = new Camera(video, {
                mirror: true,
                enableOnInactiveState: true,
                onFrame: async () => {
                    videoCanvas.width = video.width;
                    videoCanvas.height = video.height;
                    videoCanvasCtx.drawImage(video, 0, 0, video.width, video.height);
                    humanseg.drawHumanSeg(videoCanvas, canvas1);
                }
            });
        }

        let camera = null;
        const loadingDom = document.getElementById('isLoading');
        const video = document.getElementById('video') as HTMLVideoElement;
        const videoToolDom = document.getElementById('video-tool');
        const canvas1 = document.getElementById('demo') as HTMLCanvasElement;
        const videoCanvas = document.createElement('canvas') as HTMLCanvasElement;
        const videoCanvasCtx = videoCanvas.getContext('2d');

        load();

        sendShowLog('pdjs_humanStream');

        // 视频开始播放，loading消失
        video && video.addEventListener('loadeddata', async function () {
            loadingDom && loadingDom.remove();
        });

        // 点击视频控制按钮，实现视频播放/截图/暂停功能
        videoToolDom.addEventListener('click', function (e: Event) {
            const target = e.target as HTMLElement;
            if (target.id === 'start') {
                camera.start();
                sendClickLog('pdjs_humanStream', 'video_start');
            }
            if (target.id === 'pause') {
                camera.pause();
                sendClickLog('pdjs_humanStream', 'video_pause');
            }
        });
    }
}

